import { css } from '@emotion/react';

const makePageLayoutStyling = ({
  theme,
  isCountdownTimerEnabled,
  isPrivacyPolicyEnabled,
}) => {
  return {
    gridContainer: css({
      position: 'relative',
      height: '100%',
      backgroundColor: theme.mvf.palette.background.widgetBackgroundColor,
      flexWrap: 'nowrap',
    }),
    form: css({
      height: '100%',
    }),
    header: css({
      width: '100%',
    }),
    privacyPolicyContainer: css({
      display: 'flex',
      justifyContent: 'space-between',
      flexDirection: 'column',
      ...(isPrivacyPolicyEnabled &&
        isCountdownTimerEnabled && {
          [theme.breakpoints.up('tabletSmall')]: {
            flexDirection: 'row',
          },
        }),
    }),
    countdownTimerWrapper: css({
      textAlign: 'center',
      marginBottom: theme.mvf.spacing.medium,
      ...(isPrivacyPolicyEnabled && {
        marginBottom: theme.mvf.spacing.small,
        [theme.breakpoints.up('tabletSmall')]: {
          paddingRight: theme.mvf.spacing.medium,
          textAlign: 'left',
        },
      }),
    }),
    privacyPolicyWrapper: css({
      textAlign: 'center',
      maxwidth: '24%',
      ...(isCountdownTimerEnabled && {
        [theme.breakpoints.up('tabletSmall')]: {
          textAlign: 'right',
          flexShrink: 0,
        },
      }),
    }),
    grid: css({
      paddingLeft: 10,
      paddingRight: 10,
    }),
  };
};

export default makePageLayoutStyling;
